module.exports = __webpack_public_path__ + "img/giftcard_active.9f294cd7.svg";